// v187 — لوحة إدارة أسعار تكلفة المنتجات (cost_price) لدور operations/admin.
// إدخال لمرة واحدة لكل منتج، ويُستخدم لحساب قيمة الإتلاف تلقائيًا.
import React, { useEffect, useState } from "react";
import { api } from "./lib/api";
import { showToast as showToastRaw } from "./lib/theme";
import { InfoTip } from "./components/InfoTip";

const showToast = (msg, kind = "info") => {
  try { showToastRaw(msg, kind); } catch (_e) { /* silent */ }
};
const fmErr = (e) => e?.response?.data?.detail || e?.message || "خطأ";

const btn = {
  padding: "6px 12px", border: "none", borderRadius: 6,
  fontSize: 12, fontWeight: 700, cursor: "pointer",
};
const inp = {
  padding: "6px 10px", border: "1px solid var(--border)",
  borderRadius: 6, fontSize: 13, width: 100, textAlign: "center",
};

export default function ProductCostPricesPanel() {
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [q, setQ] = useState("");
  const [drafts, setDrafts] = useState({});
  const [savingId, setSavingId] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/products/catalog", { params: { active_only: true, limit: 500 } });
      setProducts(data.items || []);
    } catch (e) { showToast(fmErr(e), "error"); }
    setLoading(false);
  };
  useEffect(() => { if (open) load(); }, [open]);

  const save = async (p) => {
    const raw = drafts[p.id];
    if (raw === undefined || raw === "") return;
    const n = Number(raw);
    if (!Number.isFinite(n) || n < 0) { showToast("أدخل رقمًا صحيحًا", "error"); return; }
    setSavingId(p.id);
    try {
      await api.patch(`/products/catalog/${p.id}`, { cost_price: n });
      showToast(`✅ حُفظ سعر تكلفة ${p.name}`, "success");
      setDrafts((d) => { const c = { ...d }; delete c[p.id]; return c; });
      load();
    } catch (e) { showToast(fmErr(e), "error"); }
    setSavingId("");
  };

  const filtered = products.filter((p) => !q.trim() || (p.name || "").includes(q.trim()));
  const missingCount = products.filter((p) => p.cost_price == null).length;

  return (
    <div data-testid="cost-prices-panel"
      style={{ background: "#FEFBF3", border: `1px solid ${missingCount > 0 ? "#D97706" : "var(--border)"}`,
        borderRadius: 10, marginBottom: 14, overflow: "hidden" }}>
      <button onClick={() => setOpen((x) => !x)} data-testid="cost-prices-toggle"
        style={{
          width: "100%", padding: "12px 16px", background: "transparent",
          border: "none", cursor: "pointer", display: "flex",
          justifyContent: "space-between", alignItems: "center",
        }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 16 }}>💵</span>
          <div style={{ textAlign: "start" }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: "var(--brown-deep)" }}>
              أسعار تكلفة المنتجات
            </div>
            <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 2 }}>
              {missingCount > 0
                ? `🟡 ${missingCount} صنف بلا سعر تكلفة — أضِفه لدقة بطاقة "التالف هذا الشهر"`
                : "كل الأصناف لها سعر تكلفة ✓"}
            </div>
          </div>
        </div>
        <span style={{ fontSize: 12, color: "var(--muted)" }}>{open ? "▲ إغلاق" : "▼ فتح"}</span>
      </button>

      {open && (
        <div style={{ padding: "0 16px 16px" }}>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث باسم المنتج…"
            data-testid="cost-prices-search"
            style={{ padding: "8px 12px", border: "1px solid var(--border)", borderRadius: 6,
              width: "100%", boxSizing: "border-box", marginBottom: 10, fontSize: 13 }} />
          {loading && <div style={{ textAlign: "center", padding: 16, color: "var(--muted)" }}>جاري التحميل…</div>}
          {!loading && (
            <div style={{ maxHeight: 340, overflowY: "auto" }}>
              <table style={{ width: "100%", fontSize: 12.5, borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F3EAD5", position: "sticky", top: 0 }}>
                    <th style={{ padding: 8, textAlign: "start" }}>المنتج</th>
                    <th style={{ padding: 8, textAlign: "center" }}>الحالي</th>
                    <th style={{ padding: 8, textAlign: "center" }}>سعر التكلفة الجديد (ر.س)</th>
                    <th style={{ padding: 8 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((p) => {
                    const missing = p.cost_price == null;
                    return (
                      <tr key={p.id} style={{ borderTop: "1px solid var(--border)" }}
                        data-testid={`cost-row-${p.id}`}>
                        <td style={{ padding: 8 }}>
                          {missing && <span style={{ marginInlineEnd: 4 }}><InfoTip text="بلا سعر تكلفة" />🟡</span>}
                          {p.name}
                        </td>
                        <td style={{ padding: 8, textAlign: "center", fontWeight: 700,
                          color: missing ? "#D97706" : "var(--brown-deep)" }}>
                          {missing ? "—" : `${p.cost_price} ر.س`}
                        </td>
                        <td style={{ padding: 8, textAlign: "center" }}>
                          <input type="number" min="0" step="0.01"
                            value={drafts[p.id] ?? ""} onChange={(e) => setDrafts((d) => ({ ...d, [p.id]: e.target.value }))}
                            placeholder="0.00" data-testid={`cost-input-${p.id}`} style={inp} />
                        </td>
                        <td style={{ padding: 8 }}>
                          <button onClick={() => save(p)} disabled={savingId === p.id || !drafts[p.id]}
                            data-testid={`cost-save-${p.id}`}
                            style={{ ...btn, background: "var(--brown-deep)", color: "#fff",
                              opacity: (savingId === p.id || !drafts[p.id]) ? 0.5 : 1 }}>
                            {savingId === p.id ? "…" : "حفظ"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  {filtered.length === 0 && (
                    <tr><td colSpan="4" style={{ padding: 20, textAlign: "center", color: "var(--muted)" }}>
                      لا توجد نتائج
                    </td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
